import { Controller } from "@hotwired/stimulus";
import Swiper, { Pagination, Autoplay, Navigation } from "swiper";

export default class extends Controller {
    static targets = [
        'swiper',
        'prev',
        'pagination',
        'next',
    ]

    connect() {
        Swiper.use([Pagination, Navigation])

        this.swiper = new Swiper(
            this.element,
            {
                loop: true,
                navigation: {
                    prevEl: this.prevTarget,
                    nextEl: this.nextTarget,
                },
                // autoplay: {
                    // delay: 10000,
                // },
                pagination: {
                    el: this.paginationTarget,
                    clickable: false,
                    type: "fraction",
                }
            },
        );
    }

    disconnect() {
        this.swiper.destroy();
    }
}
